import React  from 'react';
import { Box,  Typography } from '@mui/material';


function ListItem(props)
{
return(
<Box>
<Typography variant='subtext1'>{props.item}</Typography>
</Box>
)
}

export default ListItem